var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Common/utils.ts";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import * as smApi from '@gmini/sm-api-sdk';
import { nodeToApiTypeMap } from "../../classifier-service/adapters";
import { getBimNode } from "../Search/utils";
import { getNode } from "../../classifier-service";
export function fetchViewerToken(keycloak) {
  //TODO промисифицировал, потому что вьювер ожидает ожидает промис в пропсах. Надо переделать пропс во вьювере(согласовать с теми кто им пользуется)
  return new Promise(function (resolveOuter) {
    return resolveOuter({
      accessToken: keycloak.token,
      expiresAt: keycloak.tokenParsed.exp
    });
  });
}
export function getViewerModelUrl(modelUrn, viewerDerivatives, onError) {
  var _viewerDerivatives$fi, _viewerDerivatives$fi2, _viewerDerivatives$fi3;

  var url = viewerDerivatives === null || viewerDerivatives === void 0 ? void 0 : (_viewerDerivatives$fi = viewerDerivatives.files.find(function (file) {
    return file.urn === modelUrn;
  })) === null || _viewerDerivatives$fi === void 0 ? void 0 : (_viewerDerivatives$fi2 = _viewerDerivatives$fi.derivatives) === null || _viewerDerivatives$fi2 === void 0 ? void 0 : (_viewerDerivatives$fi3 = _viewerDerivatives$fi2.find(function (_ref) {
    var role = _ref.role;
    return role === '3d';
  })) === null || _viewerDerivatives$fi3 === void 0 ? void 0 : _viewerDerivatives$fi3.resource;

  if (!url) {
    var urlNotFoundErrorText = "Url not found for model with urn: ".concat(modelUrn);
    onError === null || onError === void 0 ? void 0 : onError('Ошибка загрузки данных модели');
    throw new Error(urlNotFoundErrorText);
  }

  return url;
}
export function getViewerId(_ref2) {
  var node = _ref2.node,
      viewerRef = _ref2.viewerRef,
      nodes = _ref2.nodes,
      getNodeFunc = _ref2.getNodeFunc;
  var model = node.type === 'BimModelNode' ? node : getNodeFunc(nodes, {
    id: node.modelId,
    type: 'BimModelNode'
  });

  if (!model) {
    throw new Error("Model not found, node: ".concat(node.type, " with id ").concat(node.id));
  }

  return viewerRef.urn;
} // Validates if array contain different models

export function validateModelTypes(models) {
  if (models.every(function (m) {
    return m.modelType === 'ForgeModel';
  }) || models.every(function (m) {
    return m.modelType === 'GstationModel';
  })) {
    return;
  }

  throw new Error("Different models was found ".concat(models === null || models === void 0 ? void 0 : models.map(function (m) {
    return m.modelType;
  }).join(':')));
}
export var prepareViewerRefs = function prepareViewerRefs(viewerRefs, bimNode, nodes) {
  return viewerRefs.reduce(function (acc, viewerRef) {
    var viewerId = getViewerId({
      node: bimNode,
      viewerRef: viewerRef,
      nodes: nodes,
      getNodeFunc: getNode
    });
    var externalIds = acc[viewerId] || [];
    externalIds.push(viewerRef.externalId);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, viewerId, externalIds));
  }, {});
};
export var getViewerRefs = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(node, nodes) {
    var bimNode, viewerRefs, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bimNode = getBimNode(node, nodes);

            if (bimNode) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", null);

          case 3:
            viewerRefs = prepareViewerRefs(bimNode.viewerRefs || [], bimNode, nodes);

            if (!(bimNode.type !== 'BimModelNode' && bimNode.type !== 'BimElementNode' && bimNode.isGenerated)) {
              _context.next = 9;
              break;
            }

            _context.next = 7;
            return smApi.BimModel.fetchViewerRefs.defaultContext({
              id: bimNode.id,
              modelId: bimNode.modelId,
              modelVersion: bimNode.modelVersion,
              type: nodeToApiTypeMap[bimNode.type]
            });

          case 7:
            res = _context.sent;
            viewerRefs = prepareViewerRefs(res, bimNode, nodes);

          case 9:
            return _context.abrupt("return", viewerRefs);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getViewerRefs(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();